import { render, staticRenderFns } from "./blackresultmoneytop.vue?vue&type=template&id=46486736&scoped=true&"
import script from "./blackresultmoneytop.vue?vue&type=script&lang=js&"
export * from "./blackresultmoneytop.vue?vue&type=script&lang=js&"
import style0 from "./blackresultmoneytop.vue?vue&type=style&index=0&id=46486736&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46486736",
  null
  
)

export default component.exports